(function() {
    angular
        .module("app")
        .factory("alertsService", alertsService)

    alertsService.$inject = [
        "$rootScope",
        "$http"
    ]

    function alertsService(
        $rootScope,
        $http
    ) {
        var service = {}

        var getDeviceURL = function(deviceCategory) {
            if (deviceCategory === "Tracker") {
                return "/trackers/"
            }
            return "/message_boards/"
        }

        /**
            Get all alerts
            @param {string} notFixed
            @returns {*}
         **/
        service.getAlerts = function(type) {

            let alertSet = "" // All

            if (type === "NotFixed") {
                alertSet = "?not_fixed=true"
            } else if (type === "Fixed") {
                alertSet = "?fixed=true"
            }

            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/alerts" + alertSet
            }).then(getAlertsComplete, getAlertsFailed)

            function getAlertsComplete(response) {
                return response.data
            }

            function getAlertsFailed(error) {
                console.error(error)
            }
        }

        /**
            Get alert count
            @returns {*}
         **/
        service.getAlertCount = function() {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/alerts?count=1"
            }).then(getAlertCountComplete, getAlertCountFailed)

            function getAlertCountComplete(response) {
                return response.data
            }

            function getAlertCountFailed(error) {
                console.error(error)
            }
        }

        /**
            Get single alert
            @param {string} deviceCategory
            @param {int}    deviceID
            @param {int}    alertID
            @returns {*}
         **/
        service.getAlert = function(deviceCategory, deviceID, alertID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/alerts/" + alertID
            }).then(getAlertComplete, getAlertFailed)

            function getAlertComplete(response) {
                return response.data
            }

            function getAlertFailed(error) {
                console.error(error)
            }
        }

        /**
            Update single alert
            @param {string} deviceCategory
            @param {int}    deviceID
            @param {int}    alertID
            @param {string} formData
            @param {func}   successCallback
            @param {func}   failureCallback
            @returns {*}
         **/
        service.updateAlert = function(deviceCategory, deviceID, alertID, formData, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/alerts/" + alertID + "?alert[fixed]=" + formData.fixed + "&alert[comments]=" + formData.comments || ""
            }).then(updateAlertComplete, updateAlertFailed)

            function updateAlertComplete(response) {
                if (successCallback !== undefined) {
                    successCallback(response)
                }
                return response.data
            }

            function updateAlertFailed(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        return service
    }
})()
